/* eslint-disable @typescript-eslint/promise-function-async */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from './core/guards/auth-guard.service';
import { NotFoundComponent } from './modules/general/not-found/not-found.component';
import { RouteUtils } from './shared/utils/route/route.util';

const routes: Routes = [
	{
		path: RouteUtils.endpoints.auth.path,
		loadChildren: () =>
			import('./modules/auth/auth.module').then((m) => m.AuthModule),
	},
	{
		path: '',
		canActivateChild: [AuthGuardService],
		loadChildren: () =>
			import('./sanus/sanus.module').then((m) => m.SanusModule),
	},
	{ path: '**', component: NotFoundComponent }, // Redireciona rotas não encontradas para a tela de login
];

@NgModule({
	exports: [RouterModule],
	imports: [RouterModule.forRoot(routes)],
})
export class AppRoutingModule {}
